import React, { useState } from "react";
import "../App.css"; // uses your existing `.summary-button`, `.search-input`, etc.

const EmailSignup = () => {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState("");

  const handleEmailSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitted(false);

    try {
      const res = await fetch("https://7efu8nno5m.execute-api.us-west-1.amazonaws.com/dev/signup", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });

      if (!res.ok) {
        const data = await res.json();
        throw new Error(data.error || "Something went wrong");
      }

      setSubmitted(true);
      setEmail("");
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div className="email-signup">
      <h3>Get Notified When We Update Treatments</h3>
      <form onSubmit={handleEmailSubmit}>
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Enter your email"
          className="search-input"
          required
          style={{ maxWidth: "280px", marginRight: "10px" }}
        />
        <button type="submit" className="summary-button">Notify Me</button>
      </form>
      {submitted && <p className="success">You're signed up!</p>}
      {error && <p className="error">Oops: {error}</p>}
    </div>
  );
};

export default EmailSignup;
